import React, { useState, useEffect } from 'react';
import {
  Box,
  Select,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  FormControl,
  CircularProgress,
  Paper,
  Grid,
  Typography,
  MenuItem
} from '@mui/material';
import api from "../../services/api";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
// import {
//   TextField,
//   Select,
//   Checkbox,
//   SelectUF,
// } from '../../components';
import { useStoreState, useStoreActions } from 'easy-peasy';
// import HelpDialog from './HelpDialog.js';

yup.setLocale(pt);


// const InstFinSelect = ({ useFormRef, schema }) => {
//   const [listaInstFinanceiras, setListaInstFinanceiras] = React.useState([]);
//   let startLoading = useStoreActions((actions) => actions.nav.startLoading);
//   let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
//   const [mounted, setMounted] = React.useState(false);

//   React.useEffect(async () => {
//     startLoading();
//     try {
//       setListaInstFinanceiras((await api.http.get('/inst-financeiras')).data);
//       stopLoading();
//       setMounted(true);
//     } catch (error) {
//       stopLoading({
//         message: error.toString(),
//         severity: 'error'
//       });
//     }
//   }, []);

//   return (
//     <FormControl sx={{ my: 2 }} fullWidth>
//       {mounted &&
//         <Select
//           required
//           field="instFinanceiraId"
//           useFormRef={useFormRef}
//           schema={schema}
//           options={listaInstFinanceiras}
//           getOptionLabel={option => option.nome}
//         />
//       }
//     </FormControl>
//   );
// };

const DialogoRegiaoUsuario
  = ({ open, onClose }) => {
    let loading = useStoreState((state) => state.nav.loading);
    let startLoading = useStoreActions((actions) => actions.nav.startLoading);
    let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
    const [regioes, setRegioes] = useState([]);
    const [usuariosEsquerda, setUsuariosEsquerda] = useState([]);
    const [usuariosDireita, setUsuariosDireita] = useState([]);
    const [regiaoSelecionada, setRegiaoSelecionada] = useState(null);

    // Carrega as regiões disponíveis
    const loadRegioes = async () => {
      try {
        const response = await api.http.get('/regioes');
        setRegioes(response.data);
      } catch (error) {
        console.error("Erro ao carregar regiões:", error);
      }
    };

    // Carrega os usuários com base na região selecionada
    const loadUsuarios = async (regiaoId) => {
      try {
        const [esquerda, direita] = await Promise.all([
          api.http.get(`/regioes/user/byuf/${regiaoId}`), // API para usuários do mesmo estado, não vinculados
          api.http.get(`/regioes/user/byregiao/${regiaoId}`) // API para usuários vinculados
        ]);

        setUsuariosEsquerda(esquerda.data);
        setUsuariosDireita(direita.data);
      } catch (error) {
        console.error("Erro ao carregar usuários:", error);
      }
    };

    useEffect(() => {
      loadRegioes();
    }, []);

    const handleRegiaoChange = (event) => {
      const regiaoId = event.target.value;
      setRegiaoSelecionada(regiaoId);
      loadUsuarios(regiaoId);
    };

    const handleVincularUsuario = async (usuario) => {
      try {
        await api.http.post(`/regioes/vincular/usuario`, { usuarioId: usuario.id, regiaoId: regiaoSelecionada });
        setUsuariosEsquerda((prev) => prev.filter((u) => u.id !== usuario.id));
        setUsuariosDireita((prev) => [...prev, usuario]);
      } catch (error) {
        console.error("Erro ao vincular usuário:", error);
      }
    };

    const handleRemoverVinculo = async (usuario) => {
      try {
        await api.http.post(`/regioes/desvincular/usuario`, { usuarioId: usuario.id, regiaoId: regiaoSelecionada });
        setUsuariosDireita((prev) => prev.filter((u) => u.id !== usuario.id));
        setUsuariosEsquerda((prev) => [...prev, usuario]);
      } catch (error) {
        console.error("Erro ao remover vínculo:", error);
      }
    };

    const close = (reload = false) => {
      onClose(reload);
    };


    return (
      <Dialog open={open} onClose={() => close()}>
        <DialogTitle>Usuários por Unidade Operacional</DialogTitle>
        <DialogContent>
          <Box sx={{ width: '100%' }}>
            <Paper variant="outlined" sx={{ width: '100%', my: 3, p: 3 }}>
              {/* Select com as regiões */}
              <Typography variant="h6" gutterBottom>Selecione uma Região</Typography>
              <Select
                fullWidth
                value={regiaoSelecionada || ''}
                onChange={handleRegiaoChange}
                displayEmpty
              >
                <MenuItem value="" disabled>Escolha uma região</MenuItem>
                {regioes.map((regiao) => (
                  <MenuItem key={regiao.id} value={regiao.id}>
                    {`${regiao.label} (${regiao.estado})`}
                  </MenuItem>
                ))}
              </Select>

              {/* Grids de usuários */}
              {regiaoSelecionada && (
                <Grid container spacing={3} sx={{ mt: 3 }}>
                  {/* Grid da esquerda */}
                  <Grid item xs={6}>
                    <Typography variant="subtitle1">Não Vinculados</Typography>
                    <Paper variant="outlined" sx={{ p: 2, maxHeight: 400, overflow: 'auto' }}>
                      {usuariosEsquerda.map((usuario) => (
                        <Box key={usuario.id} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => handleVincularUsuario(usuario)}
                            sx={{ mr: 2 }}
                          >
                            Vincular
                          </Button>
                          <Typography>{usuario.nome}</Typography>
                        </Box>
                      ))}
                    </Paper>
                  </Grid>

                  {/* Grid da direita */}
                  <Grid item xs={6}>
                    <Typography variant="subtitle1">Vinculados</Typography>
                    <Paper variant="outlined" sx={{ p: 2, maxHeight: 400, overflow: 'auto' }}>
                      {usuariosDireita.map((usuario) => (
                        <Box key={usuario.id} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={() => handleRemoverVinculo(usuario)}
                            sx={{ mr: 2 }}
                          >
                            Remover
                          </Button>
                          <Typography>{usuario.nome}</Typography>
                        </Box>
                      ))}
                    </Paper>
                  </Grid>
                </Grid>
              )}
            </Paper>
          </Box>
        </DialogContent>
        <DialogActions>
          {loading > 0 && <CircularProgress
            size={30}
            sx={{
              'position': 'absolute',
              'left': 25,
              'bottom': 12
            }} />}
          <Button color="inherit"
            onClick={() => close()}
          // disabled={isSubmitting}
          >
            OK
          </Button>
          {/* <Button color="primary"
            onClick={handleSubmit(onSave)}
            disabled={!isDirty || isSubmitting}>
            SALVAR
          </Button> */}
        </DialogActions>
      </Dialog>

    );
  };


export default DialogoRegiaoUsuario
  ;
